import { IUnorderedArrivalResult } from '../domains/entities/IUnorderedArrivalResult';
import { GetOrderResponseResult } from '@/coreInfrastructureModule/axios/generated/orderManage/api';
import { findOrderStatusOrNull, OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { Order } from '@/coreDomainsModule/entities/order';
import { OrderFactory } from '@/coreDomainsModule/factories/orderFactory';
import { PartialDeliveryAdapter } from './partialDeliveryAdapter';
import { UserAccountFactory } from '@/coreDomainsModule/factories/userAccountFactory';

/**
 *　repositoryの型をUI用に変換する
 */
export class OrderAdapter {
  /**
   * IUnorderedArrivalResponseをIUnorderedArrivalResultに変換する
   * @param response - IUnorderedArrivalResponse
   */
  public static adapt = (response: GetOrderResponseResult): IUnorderedArrivalResult => {
    const firmOrderBusiness: Order[] = [];
    const pagingOptions = response.pagingOptions;
    response.data?.forEach((order) => {
      firmOrderBusiness.push(
        OrderFactory.create({
          orderId: order.orderId,
          aggregateBusinessId: order.aggregateBusinessId,
          supplierNumber: order.supplierNumber,
          supplierName: order.supplierName,
          businessNumber: order.businessNumber,
          businessName: order.businessName,
          package: order.package,
          unit: order.unit,
          manufacturer: order.manufacturer,
          warehouseNumber: order.warehouseNumber,
          warehouse: order.warehouse,
          aggregateBusinessResponsibleUsers: order.aggregateBusinessResponsibleUsers?.map((user) =>
            UserAccountFactory.create({
              email: user.id,
              name: user.name,
              organizationId: undefined,
              role: undefined,
              profile: undefined,
              createdAt: undefined,
              updatedAt: undefined,
            })
          ),
          orderIssuedNumber: order.orderIssuedNumber,
          orderNumber: order.orderNumber,
          createdOrderDate: order.createdOrderDate,
          desiredDeliveryDate: order.desiredDeliveryDate,
          estimatedTimeOfArrival: order.estimatedTimeOfArrival,
          orderAmount: order.orderAmount,
          orderStatus: findOrderStatusOrNull(order.orderStatus) ?? OrderStatus.Unknown,
          orderNote: order.orderNote,
          // NOTE: 発注グループが1件しかこない想定
          orderGroupId: order.orderGroupList[0]?.orderGroupId,
          orderGroupName: order.orderGroupList[0]?.orderGroupName,
          invoiceNumber: order.orderGroupList[0]?.invoiceNumber,
          destinationName: order.orderGroupList[0]?.destinationName,
          upperLimitQuantity: order.orderGroupList[0]?.upperLimitQuantity,
          outputDate: order.outputDate,
          isOutOfStockExpected: order.isOutOfStockExpected,
          userCustomParameters: order.userCustomParameters,
          statusUpdateAt: order.statusUpdateAt,
          orderAlert: [],
          partialDeliveries: order.partialDeliveryList?.map((v) => PartialDeliveryAdapter.adapt(v)),
          lastUpdatedByUser: {
            email: order.lastUpdatedByUser?.id,
            name: order.lastUpdatedByUser?.name,
            organizationId: undefined,
            role: undefined,
            profile: undefined,
            createdAt: undefined,
            updatedAt: undefined,
          },
          updatedAt: order.updateAt,
          reminderMailDataId: order.reminderMailDataId ?? null,
          orderBasisId: order.orderBasisId,
          initialOrderAmount: order.initialOrderAmount,
          initialDesiredDeliveryDate: order.initialDesiredDeliveryDate,
        })
      );
    });
    return {
      result: firmOrderBusiness,
      pagingOptions: { ...pagingOptions },
    };
  };
}
